// tempexp_36140_file
import { useMemo } from 'react';

import useExperiment from 'src/hooks/useExperiment';
import { useIsZarplataPlatform } from 'src/hooks/usePlatform';
import { useSelector } from 'src/hooks/useSelector';
import { useIsHhru } from 'src/hooks/useSites';
import { CountryId } from 'src/models/countryId';

export const EXPERIMENT_NAME_REFUND_FOR_NEW_EMPLOYER = 'exp_36140_refund_for_new';

const daysIn8Weeks = 56;
function formatDateToView(dateString: string, addDays = 0) {
    const [year, month, day] = dateString.split('-').map(Number);
    const date = new Date(year, month - 1, day + addDays);
    // padStart добавит 0 если день/месяц состоит из одной цифры,
    // например 3 -> 03, но 12 оставит 12
    const formattedDay = String(date.getDate()).padStart(2, '0');
    const formattedMonth = String(date.getMonth() + 1).padStart(2, '0');
    return `${formattedDay}.${formattedMonth}`;
}

const Features = {
    refundForNewEmployerStartDate: 'refund_for_new_employer_start_date',
};
interface UseRefundForNewEmployer {
    isRefundForNewEmployerEnabled: boolean;
    shouldCheckRefundForNewEmployerExp: boolean;
    start: string | null;
    end: string | null;
}
export const useRefundForNewEmployer = (): UseRefundForNewEmployer => {
    const isRussianEmployer = useSelector(
        ({ employerCountryIdBySeller }) => employerCountryIdBySeller?.toString() === CountryId.Russia
    );
    const isNewEmployerFromPrice = useSelector(
        ({ priceProfRolesPublications }) => priceProfRolesPublications?.isNewEmployerWithoutServices
    );
    const isNewEmployerFromBuilder = useSelector(
        ({ availablePublicationTypes }) => availablePublicationTypes.data?.isNewEmployerWithoutServices
    );
    const isZp = useIsZarplataPlatform();
    const isHHRu = useIsHhru();
    const refundForNewEmployerStartDate = useSelector(
        (state) => (state.features[Features.refundForNewEmployerStartDate] as string) || ''
    );

    const { start, end } = useMemo(() => {
        const interval = {
            start: null,
            end: null,
        };
        if (refundForNewEmployerStartDate) {
            const date = new Date(refundForNewEmployerStartDate);
            if (isNaN(date.getTime())) {
                return interval;
            }
            const start = formatDateToView(refundForNewEmployerStartDate);
            const end = formatDateToView(refundForNewEmployerStartDate, daysIn8Weeks);
            return {
                start,
                end,
            };
        }
        return {
            start: null,
            end: null,
        };
    }, [refundForNewEmployerStartDate]);

    const shouldCheckExperiment =
        !isZp &&
        isHHRu &&
        isRussianEmployer &&
        Boolean(isNewEmployerFromPrice || isNewEmployerFromBuilder) &&
        !!start &&
        !!end;

    const isRefundForNewEmployerEnabled = useExperiment(
        EXPERIMENT_NAME_REFUND_FOR_NEW_EMPLOYER,
        shouldCheckExperiment,
        false
    );

    return {
        isRefundForNewEmployerEnabled,
        shouldCheckRefundForNewEmployerExp: shouldCheckExperiment,
        start,
        end,
    };
};
